export default {
  users: (state) => {
    return state.users;
  },
  user: (state) => {
    return state.user;
  },
  ordersUser: (state) => {
    return state.ordersUser;
  },
  userOptions: (state) => {
    const userOptions = [];
    state.users.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.name,
      };
      userOptions.push(pushItem);
    }
    return userOptions;
  },
  bannedUser: (state) => {
    return state.bannedUser;
  },
  roles: (state) => {
    return state.roles;
  },
  roleOptions: (state) => {
    const roleOptions = [];
    state.roles.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      roleOptions.push(pushItem);
    }
    return roleOptions;
  },
  customers: (state) => {
    return state.customers;
  },
  customerOptions: (state) => {
    const customerOptions = [];
    state.customers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.fullName,
      };
      customerOptions.push(pushItem);
    }
    return customerOptions;
  },

  blockCustomers: (state) => {
    return state.blockCustomers;
  },

  permissions: (state) => {
    return state.permissions;
  },

  employees: (state) => {
    return state.employees;
  },
  employee: (state) => {
    return state.employee;
  },

  deletedEmployees: (state) => {
    return state.deletedEmployees;
  },

  persons: (state) => {
    return state.persons;
  },
  person: (state) => {
    return state.person;
  },

  personOptions: (state) => {
    const personOptions = [];
    state.persons.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.fullName,
      };
      personOptions.push(pushItem);
    }
    return personOptions;
  },
};
